import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/B2';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得先前給付方式變更記錄
export function getInfoB2() {
    return get(`${url}/info`);
}

/**
 * sumbit
 * @param {Object} data
 */
export function submitB2(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
